import { api } from '@/api/client';
import { pickMediaUrl } from '@/api/mappers/media';
function mapProduct(r) {
    const imageUrl = pickMediaUrl(r.media, 'pathCard', 'pathThumb', 'path');
    const bonusRaw = r.bonusAmount;
    return {
        id: r.id,
        name: r.name,
        price: r.price,
        imageUrl,
        grams: r.grams ?? undefined,
        categoryId: r.categoryId,
        description: r.description || undefined,
        ingredients: r.ingredients || undefined,
        proteins: r.proteins,
        fats: r.fats,
        carbohydrates: r.carbohydrates,
        calories: r.calories,
        bonusAmount: typeof bonusRaw === 'number' ? bonusRaw : 0,
        disabledRestaurantIds: Array.isArray(r.disabledRestaurantIds) ? r.disabledRestaurantIds : [],
        modifiers: Array.isArray(r.modifiers) ? r.modifiers : [],
    };
}
export async function fetchProductsByMenuAndCategory(menuId, categoryId) {
    const { data } = await api.get(`/v1/menus/${menuId}/categories/${categoryId}/products`);
    return data.map(mapProduct);
}
